import { line_children, app_line_children } from "./menus/index"
import { getOptDes } from "./menus/optDes"
const cxVerticalLine = {
  name: "cxVerticalLine",
  desc: "线条",
  render: () => import("./render/index.vue"),
  optDes: getOptDes,
  enable: true,
  menus: {
    app: [
      {
        name: "竖线",
        children: app_line_children,
        group: "baseElement",
        thumbnail: "icon-portal-line_v",
     // enable(params) {
        //   return params.admin
        // },
        sort: 70
      }
    ],
    portal: [
      {
        name: "竖线",
        children: line_children,
        group: "baseElement",
        thumbnail: "icon-portal-line_v",
     // enable(params) {
        //   return params.admin
        // },
        sort: 70
      }
    ]
  },
  toolbars: [
    {
      name: "cxVerticalLine",
      label: "竖线",
      comp: {
        verticalLineComponentData: () => import("./toolbars/line-options-data.vue"),
        verticalLineComponentSetting: () => import("./toolbars/line-options-setting.vue"),
        verticalLineComponentStyle: () => import("./toolbars/line-options-style.vue")
      }
    }
  ]
}

export default cxVerticalLine
